import { WebPageJsonLd } from "next-seo";
import { addBaseUrl } from "./addBaseUrl";
import { Routes } from "~/routes";

// // // //

export function getBroadridgePageDescription(): string {
    return `Broadridge's Distributed Ledger Repo (DLR) is the leading distributed ledger solution transforming global repo market infrastructure.`;
}

// // // //

/**
 * Renders WebPage SEO metadata for the Broadridge Individual page using the `WebPageJsonLd` component from `next-seo`.
 */
export function BroadridgeIndividualSEO() {
    // Get yesterday's date
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    return (
        <WebPageJsonLd
            id={addBaseUrl(Routes.broadridge)}
            description={getBroadridgePageDescription()}
            lastReviewed={isoYesterday}
            reviewedBy={{
                type: "Organization",
                name: "RWA.xyz",
            }}
        />
    );
}
